export const mapReleaseGroupToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfCustomer: item.profileDevices?.length,
  }));

  return result;
};

export const releaseGroupColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "numOfCustomer", label: "Num Of Customer", align: "center" },
];
